import { ACCOUNT_ROUTES } from '@/routes'
import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

/**
 * # Use go back hook
 *
 * This hook checks if the current page was navigated to from another page
 * within the app by examining location.state.previous. If there is a
 * previous page in the navigation history, it will navigate back using
 * `navigate(-1)`. Otherwise, it will navigate to the provided default route.
 *
 * @returns A function that accepts an optional default route and handles navigation
 */
const useGoBack = (): ((defaultRoute?: string) => void) => {
  const navigate = useNavigate()
  const location = useLocation()

  return useCallback(
    (defaultRoute: string = ACCOUNT_ROUTES.base) => {
      if (location.state?.previous) {
        navigate(-1)
      } else {
        navigate(defaultRoute, { replace: true })
      }
    },
    [navigate, location.state]
  )
}

export { useGoBack }
